import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core'
import { CommonService, environment, TABLE_CONSTANTS } from '@lla-platform/core/core-util'
import {
  ArInvoicesState,
  GetInvoice,
  IInvoiceDetailResponse,
  InvoiceOperatedType
} from '@lla-platform/receivable/receivable-data-access'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Store } from '@ngxs/store'
import { Observable, finalize, map } from 'rxjs'

@UntilDestroy()
@Component({
  selector: 'lla-invoice-info',
  templateUrl: './invoice-info.component.html',
  styleUrls: ['./invoice-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InvoiceInfoComponent implements OnChanges {
  @Input() invoiceId?: string
  @Input() showCloseButton = true
  @Input() forModal = false
  @Output() invoiceInfoClosed = new EventEmitter()

  invoiceResponse$: Observable<IInvoiceDetailResponse> = inject(Store).select(
    ArInvoicesState.invoiceResponse
  )

  protected notOperatedByLla$ = this.invoiceResponse$.pipe(
    map((info) => info?.invoice?.operated === InvoiceOperatedType.NotOperatedByLLA)
  )

  isLoading = false
  websiteUrl = environment.websiteUrl
  emptyGuid = TABLE_CONSTANTS.EMPTY_GUID

  protected otherChargesExpanded = false
  protected surchargeFeesExpanded = false
  protected taxesExpanded = false

  constructor(
    private store: Store,
    public commonService: CommonService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['invoiceId']?.currentValue) {
      return
    }

    if (changes['invoiceId']?.previousValue !== changes['invoiceId']?.currentValue) {
      this.getInvoice()
    }
  }

  getInvoice() {
    if (!this.invoiceId) {
      return
    }

    this.isLoading = true

    this.store
      .dispatch(new GetInvoice(this.invoiceId))
      .pipe(
        untilDestroyed(this),
        finalize(() => {
          this.isLoading = false
        })
      )
      .subscribe()
  }
}
